import { render, staticRenderFns } from "./SettingsTabs.vue?vue&type=template&id=2d2fa1a2"
import script from "./SettingsTabs.vue?vue&type=script&lang=js"
export * from "./SettingsTabs.vue?vue&type=script&lang=js"
import style0 from "./SettingsTabs.vue?vue&type=style&index=0&id=2d2fa1a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports